import type { JobsColorPalette } from 'dashboard409a/pages/Workboard/common/constants';

export interface StatusOption {
  id: string;
  label: string;
  isArchived?: boolean;
  paletteKey?: keyof JobsColorPalette;
}

export interface UndoStatusProps {
  isUndoPending: boolean;
  secondsLeft: number;
  onUndo: () => void;
}

export interface ValuationStatusTrackerProps {
  isFromModels?: boolean;
  statusOptions: StatusOption[];
  currentStatusId?: string;
  onStatusChange?: (statusId: string) => void;
  isLoading?: boolean;
  disabled?: boolean;
  isExpanded?: boolean;
  fixedHeight?: number | 'auto';
  undoProps?: UndoStatusProps;
}

export enum StepStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  PENDING = 'pending',
}
